module.exports = __webpack_public_path__ + "static/media/opensans-semibold.ba5cde21.ttf";